import { createFileRoute, redirect } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchTaxCategoriesList } from '@/features/tax-categories/api'

import { TaxCategoriesSearchSchema } from './-models/tax-categories-search'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings/tax-categories/'
)({
  validateSearch: (search) => parse(TaxCategoriesSearchSchema, search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ search, location }) => {
    // 初回アクセス（クエリ空）の場合は `isActive=true` を既定付与する。
    // 過去データの混在を避け、現在運用に必要な税区分だけを最初に見せる。
    //
    // #3561 bug-1: 「全て」選択は `isActive='all'` を URL に残すため keys が空に
    //               ならず、ここでは redirect されない (=「全て」が機能する)。
    const keys = Object.keys(search)
    if (keys.length === 0) {
      throw redirect({
        to: location.pathname,
        search: { ...search, isActive: true }
      })
    }
  },
  loader: async ({
    abortController,
    params: { tenantKey },
    deps,
    context: { auth }
  }) => {
    // #3561 bug-1: sentinel 'all' は API レイヤでは undefined (= 絞り込みなし) に変換する
    const apiIsActive = deps.isActive === 'all' ? undefined : deps.isActive
    return {
      authUser: auth.user,
      taxCategories: await fetchTaxCategoriesList(
        { tenantKey, query: { isActive: apiIsActive } },
        abortController.signal
      )
    }
  }
})
